import {useIntl} from 'react-intl'
import {KTIcon} from '@/_metronic/helpers'
import * as Yup from 'yup'
import {Formik, Field, Form} from 'formik'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useQueryResponse} from '@/components/table/core/QueryResponseProvider'
import {InputText, FormActions, handleErrors, CustomSelect } from '@/components/form'
import {Sponsorship} from '../../core/_models'
import {updateSponsorship} from '../../core/_requests'

const schema = Yup.object({
  key: Yup.string().min(3, 'Minimum 3 characters').required('Key is required'),
  commission: Yup.number().min(0).required('Prc is required')
})

const statuses = [
  'STATUS_PENDING',
  'STATUS_APPROVED',
  'STATUS_REJECTED'
]

const SponsorshipForm = () => {
  const intl = useIntl()
  const {itemForUpdate,setItemForUpdate, setAction} = useListView()
  const {refetch} = useQueryResponse()
  const sponsorship = itemForUpdate as Sponsorship
  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  return (
    <Formik
      initialValues={{
        cookieHash: sponsorship.cookieHash,
        key: sponsorship.key,
        commission: sponsorship.commission,
        status: sponsorship.statuses.at(-1)?.status || 'STATUS_PENDING',
        channels: sponsorship.channels
      }}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          await updateSponsorship(
            sponsorship.user._id,
            values.key,
            values.status,
            values.commission
          )
          close()
          refetch()
        } catch (e: any) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {({values}) => (
        <Form id="sponsorship" className='form'>
          <div className="row">
            <div className="col-5">
              <Field
                name="key"
                type="text"
                component={InputText}
                label="Key"
                required={true}
              />
            </div>

            <div className="col-4">
              <Field
                name="status"
                component={CustomSelect}
                options={statuses.map(s => ({
                  value: s, label: intl.formatMessage({id: `P2C.SPONSORSHIP_${s}`})
                }))}
                label="Status"
                required={true}
              />
            </div>
            <div className="col-3">
              <Field
                name="commission"
                type="number"
                component={InputText}
                label="Commission (%)"
                required={true}
              />
            </div>
          </div>
          {values.channels.length > 0 && (
            <>
              <h3 className="card-title align-items-start flex-column">
                <span className="card-label fw-bold fs-3 mb-1">Channels</span>
              </h3>
              <table className="table table-striped gy-4 gs-4">
                <thead>
                  <tr className="border-bottom fs-6 fw-bold text-muted">
                    <th className="min-w-20px pb-2">Channel</th>
                    <th className="min-w-175px text-start pb-2">URL</th>
                    <th className="min-w-80px text-center pb-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {values.channels.map((c, index) => (
                    <tr key={`channel-${index}`}>
                      <td className="text-start fw-bold">{c.channel}</td>
                      <td className="text-start">{c.url}</td>
                      <td className="text-end">
                        <a href={c.url} target="_blank" rel="noopener noreferrer">
                          <KTIcon iconName="exit-right-corner" className="fs-1 me-4 text-hover-primary" />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          <Field
            position="end"
            component={FormActions}
            close={close}
          />
        </Form>
      )}
    </Formik>
  )
}

export default SponsorshipForm
